import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { BudgetListResponse, BudgetQueryParams } from '@frontend/budget/types';

export class BudgetUserClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async fetchUserBudgets(accountId: string, userId: string, queryParams?: ApiQueryParams<BudgetQueryParams>): Promise<BudgetListResponse> {
        return await this.apiPaginated(`${this.endpoint}/accounts/${accountId}/users/${userId}/budgets`, queryParams);
    }
}
